import { appConfig } from '../../insaweb.config'

export module GridLayoutHelpers {
    export function saveGridLayout(GridName: string) {      
        let grid: kendo.ui.Grid = $("#" + GridName).data("kendoGrid");
        if (grid){
            //console.log('saveGridLayout')
            let options: kendo.ui.GridOptions = grid.getOptions();
            options.dataSource = null;
            localStorage["kendo " + GridName + " options"] = kendo.stringify(options);
            //save application version information
            localStorage[GridName + "_VerisonInfo"] = appConfig.version;
        }
    
      }
    
    export function loadGridLayout(GridName: string){
        let gridOptions = localStorage["kendo " + GridName + " options"];
        if (gridOptions) {
          let version: number = parseFloat(localStorage[GridName + "_VerisonInfo"]);
          if (version === appConfig.version){
            let grid: kendo.ui.Grid = $("#" + GridName).data("kendoGrid");
            if (grid){
                let customCommands: kendo.ui.GridColumnCommandItem[] = new Array<kendo.ui.GridColumnCommandItem>();
                //retrieve all custom commands defined on the grid
                grid.options.columns.forEach((col)=>{
                  if (col.command != undefined ) {
                    col.command.forEach((comm)=>{  
                      if (comm.click !== undefined){
                          customCommands.push(comm);
                      }
                    });
                  }
                });
                
                //let clickHandler: any = grid.options.columns[2].command[0].click;
                let loadedOptions: kendo.ui.GridOptions = JSON.parse(gridOptions,(key,value) => { if (key !=="dataSource") return value; });
                loadedOptions.columns.forEach((col)=>{
                  // -->> set the title to the current text (and not the one which was saved!)
                  // assumption is that it has already been translated
                  let gcol = grid.columns.find(cg => cg.field === col.field);
                  if (gcol) {
                    col.title = gcol.title;
                  }
                  // <<-- translation of title
                  if (col.command != undefined ) {
                    col.command.forEach((command) => {
                      let savedCustomCommand: kendo.ui.GridColumnCommandItem =  (customCommands.find(c => c.name=== command.name));
                      if (savedCustomCommand != null || savedCustomCommand != undefined){
                        command.click = savedCustomCommand.click; // all this trouble, just to re-apply the click function callback, because kendo couldn't serialize it to JSON....
                      }
                    });
                  }
                });
                //loadedOptions.columns[2].command[0].click = clickHandler;
                grid.setOptions(loadedOptions);
                grid.refresh();
            }
          }
        }
      }
    
}



// WEBPACK FOOTER //
// ./app/insa-services/gridLayoutHelpers.ts